import { createAction } from 'redux-actions';

export const articlesFetch = createAction('HOME_ARTICLE_SECTION_ARTICLES_FETCH');
export const articlesSet = createAction('HOME_ARTICLE_SECTION_ARTICLES_SET');
